// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b3120b01f7f2d9c4ae1b024ba108067b.js";
};